import { Controller } from 'react-hook-form';

import { Asterisk } from '../../Asterisk';
import { DateInput } from '../../Forms/DateInput';
import { StyledLabel, StyledSmallText } from '../ControlledInputs.styled';

import { ControlledBirthDateInputProperties } from './ControlledBirthDate.types';
import { validateDateOfBirth } from './utils';

export function ControlledBirthDateInput({
    control,
    disabled,
    showMinAgeMessage = true,
    isRejoin = false,
    placeholder,
    isAffiliateRegistration = false,
}: ControlledBirthDateInputProperties) {
    const minAge = isAffiliateRegistration ? 18 : 16;
    return (
        <>
            <Controller
                name="dob"
                control={control}
                rules={{
                    required: 'Date of Birth is required',
                    // Add ignore to avoid redundant test coverage for this function
                    validate: /* istanbul ignore next */ value =>
                        validateDateOfBirth(value, minAge),
                }}
                render={({
                    field: { value, onBlur, onChange },
                    fieldState: { error, invalid, isDirty },
                }) => {
                    return (
                        <>
                            <StyledLabel $hasPaddingTop htmlFor="dob">
                                Date of Birth
                                <Asterisk spaceBefore />
                            </StyledLabel>
                            <DateInput
                                id="dob"
                                disabled={disabled}
                                placeholder={placeholder}
                                onBlur={onBlur}
                                onChange={onChange}
                                errorMessage={error?.message}
                                isInvalid={invalid}
                                value={value}
                                autoComplete="bday"
                                iconElementRight={{
                                    name:
                                        !invalid && isDirty ? 'tick' : 'blank',
                                }}
                            />
                        </>
                    );
                }}
            />

            {showMinAgeMessage && !isRejoin && !isAffiliateRegistration && (
                <StyledSmallText gutterBottom={false}>
                    Members must be 16 or over. If under 18 you will need to
                    complete a compulsory online Kickstart Session, and may be
                    asked for valid proof of age.
                </StyledSmallText>
            )}
            {isAffiliateRegistration && (
                <StyledSmallText gutterBottom={false}>
                    Members must be 18 or over.
                </StyledSmallText>
            )}
        </>
    );
}

export default ControlledBirthDateInput;
